import { useEffect, useRef, useState } from "react";
import { copyToClipboard } from "./utils";

const RESET_MS = 1200;

// Inline copy confirmation — no snackbar. A control swaps to a checkmark (or
// a brief error tint) for a moment, then reverts on its own.
export const useCopyFeedback = () => {
  const [state, setState] = useState("idle"); // "idle" | "copied" | "error"
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  useEffect(() => {
    if (state === "idle") return undefined;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setState("idle"), RESET_MS);
    return () => clearTimeout(timerRef.current);
  }, [state]);

  const copy = (text) => {
    copyToClipboard(
      text,
      () => setState("copied"),
      () => setState("error")
    );
  };

  return { state, copy };
};
